import {request} from '../utils/request';
import {POST} from '../constants/API_CONSTANTS';
import {GET_CUSTOMER_INSIGHTS} from '../constants/API_ENDPOINTS';

const getCustomerInsightsApi = async (locationId, payload) => {
  return request(
    POST,
    GET_CUSTOMER_INSIGHTS(locationId),
    {data: payload},
    {silent: true}
  );
};

export default getCustomerInsightsApi;
